module.exports = __webpack_public_path__ + "img/home-pink.627c92ef.svg";